import type { CityConfig } from "@/pages/city-template/types";

export const statenIslandConfig: CityConfig = {
  city: "Staten Island",
  state: "New York",
  stateAbbr: "NY",
  slug: "staten-island",
  route: "/cities/staten-island",
  title: "Emergency & Expedited Passport Staten Island NY | Same Day Passport",
  metaDescription:
    "Emergency passport Staten Island NY — same day, 24-hour, and 3-5 day expedited passport processing for Richmond County. Fast Passport Center serves all Staten Island neighborhoods from St. George to Tottenville.",
  h1: "Emergency & Expedited Passport Services in Staten Island, NY",
  heroSubtitle:
    "Staten Island's fast passport solution — from St. George to Tottenville. Whether you're flying out of JFK, Newark, or LaGuardia, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Staten%20Island%20New%20York%20with%20the%20Verrazzano-Narrows%20Bridge%20spanning%20the%20water%2C%20the%20Staten%20Island%20Ferry%20terminal%20visible%20in%20foreground%2C%20suburban%20neighborhoods%20with%20tree-lined%20streets%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20coastal%20New%20York%20borough%20scene%20with%20bridge%20and%20harbor&width=1600&height=700&seq=ny-staten-island-hero-001&orientation=landscape",
  heroImageAlt: "Staten Island New York skyline with Verrazzano Bridge and harbor at golden hour",
  geoPosition: "40.5795; -74.1502",
  geoPlacename: "Staten Island, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~15 miles (via Staten Island Ferry to Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Staten Island", zips: "10301, 10302, 10303, 10304, 10305, 10306, 10307, 10308, 10309, 10310, 10311, 10312, 10313, 10314" },
    { name: "St. George", zips: "10301" },
    { name: "Tompkinsville", zips: "10304" },
    { name: "Great Kills", zips: "10308" },
    { name: "Tottenville", zips: "10307" },
    { name: "New Dorp", zips: "10306" },
    { name: "Eltingville", zips: "10312" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
    { name: "Brooklyn", zips: "11201-11256" },
    { name: "Queens", zips: "11001-11697" },
    { name: "The Bronx", zips: "10451-10475" },
    { name: "Bayonne", zips: "07002" },
    { name: "Jersey City", zips: "07030, 07302-07311" },
    { name: "Elizabeth", zips: "07201-07208" },
    { name: "Perth Amboy", zips: "08861-08862" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Staten Island travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Staten Island residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Richmond County & Beyond",
      desc: "Staten Island, Bayonne, Perth Amboy, and all of Richmond County — we serve all of Staten Island and nearby New Jersey communities.",
    },
  ],
  testimonials: [
    {
      name: "Maria G.",
      location: "St. George, Staten Island",
      rating: 5,
      text: "Had a family emergency in Italy and needed my passport within 3 days. Fast Passport Center delivered in 2. I was able to take the ferry to Manhattan and ship everything same day.",
      service: "Emergency Passport",
    },
    {
      name: "Anthony R.",
      location: "Great Kills, Staten Island",
      rating: 5,
      text: "Renewed my expired passport for a cruise to the Caribbean. Chose the 5-day option and had it back in 4. They reviewed everything before submission.",
      service: "Passport Renewal",
    },
    {
      name: "Jennifer K.",
      location: "New Dorp, Staten Island",
      rating: 5,
      text: "First-time passport for my daughter's study abroad program. The agent walked us through the DS-11 form and acceptance clerk process. Processed in 5 days.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "staten-island-1",
      name: "Staten Island Main Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "550 Manor Road",
      city: "Staten Island",
      state: "NY",
      zip: "10314",
      phone: "718-477-8300",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "Castleton Corners area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Staten Island passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "staten-island-2",
      name: "St. George Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "45 Bay Street",
      city: "Staten Island",
      state: "NY",
      zip: "10301",
      phone: "718-815-2700",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "St. George (near ferry terminal)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for St. George, Tompkinsville, and North Shore Staten Island residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "staten-island-3",
      name: "Great Kills Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "1100 Hylan Boulevard",
      city: "Staten Island",
      state: "NY",
      zip: "10305",
      phone: "718-273-4845",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Great Kills / South Shore",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Great Kills, Eltingville, New Dorp, and South Shore Staten Island communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Staten Island?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Staten Island residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Staten Island?",
      a: "The Staten Island Main Post Office at 550 Manor Road is the major passport acceptance facility. The St. George Post Office at 45 Bay Street and Great Kills Post Office at 1100 Hylan Boulevard are also convenient options. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in Staten Island?",
      a: "Yes — passport photos are widely available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations throughout Staten Island. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Staten Island?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Staten Island passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. Staten Island residents can simply ship documents via overnight courier. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Staten Island?",
      a: "The fastest way to renew a passport in Staten Island is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Staten Island?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Staten Island and all Richmond County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Staten Island?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Staten Island. We serve Richmond County and all Staten Island neighborhoods through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Staten Island", address: "various CVS locations across Staten Island including St. George, New Dorp, and Great Kills", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Staten Island", address: "various Walgreens locations throughout Staten Island", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Staten Island", address: "various UPS Store locations on Staten Island", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — Staten Island", address: "various FedEx Office locations across Staten Island", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
    { name: "Walmart Photo Center — Staten Island", address: "Walmart locations on Staten Island", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Staten Island",
      address: "1775 South Avenue, Staten Island, NY 10314",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Staten Island DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Brooklyn",
      address: "625 Atlantic Avenue, Brooklyn, NY 11217",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Brooklyn DMV office serving Staten Island residents who commute to Brooklyn. Appointments recommended.",
      featured: false,
    },
    {
      name: "NYS DMV — Jersey City",
      address: "438 Summit Avenue, Jersey City, NJ 07306",
      hours: "Mon-Fri 8:00 AM - 4:30 PM",
      note: "New Jersey MVC office for New Jersey residents near Staten Island. Appointments required.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~35 miles from Staten Island",
      address: "JFK Access Road, Jamaica, NY 11430",
      note: "Major international gateway with direct flights to Europe, Asia, and worldwide destinations. Accessible via the Staten Island Ferry to Manhattan and then transit to JFK.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport",
      featured: true,
    },
    {
      code: "EWR",
      name: "Newark Liberty International Airport",
      distance: "~12 miles from Staten Island",
      address: "3 Brewster Road, Newark, NJ 07114",
      note: "Closest major airport to Staten Island via the Goethals Bridge. Direct flights to Europe and worldwide destinations.",
      flightUrl: "https://www.newarkairport.com/",
      flightLabel: "Newark Airport",
      featured: true,
    },
    {
      code: "LGA",
      name: "LaGuardia Airport",
      distance: "~22 miles from Staten Island",
      address: "Ditmars Boulevard, Flushing, NY 11369",
      note: "Domestic-focused airport with flights to major U.S. cities. Accessible via Staten Island Ferry to Manhattan and then transit.",
      flightUrl: "https://www.laguardiaairport.com/",
      flightLabel: "LaGuardia Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Staten Island travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Staten Island residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Staten Island residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Staten Island residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Staten Island, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Staten Island residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Staten Island travelers with immediate departure needs from JFK, Newark, or LaGuardia." },
    { name: "Passport Renewal", description: "Fast passport renewal for Staten Island residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Staten Island residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Staten Island residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Staten Island and Richmond County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Staten Island." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Staten Island travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Staten Island travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Staten Island team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier from Staten Island to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Staten Island address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "The Bronx", route: "/cities/the-bronx" },
    { name: "Long Island", route: "/cities/long-island" },
    { name: "Bay Shore", route: "/cities/bay-shore" },
    { name: "Commack", route: "/cities/commack" },
    { name: "Hicksville", route: "/cities/hicksville" },
    { name: "Huntington", route: "/cities/huntington" },
    { name: "Islip", route: "/cities/islip" },
    { name: "Levittown", route: "/cities/levittown" },
    { name: "Smithtown", route: "/cities/smithtown" },
    { name: "West Babylon", route: "/cities/west-babylon" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "Binghamton", route: "/cities/binghamton" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Staten Island and all of Richmond County as a remote courier service. We do not have a physical office in Staten Island, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Staten Island area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Staten Island and all of Richmond County. From St. George to Tottenville, from Great Kills to New Dorp — we serve all of Staten Island and nearby New Jersey communities.",
  nearbyCitiesIntro:
    "We proudly serve Staten Island and all surrounding communities across Richmond County and nearby New Jersey. Whether you're in St. George, Bayonne, or Perth Amboy, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Staten Island customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Staten Island travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Staten Island travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Staten Island. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default statenIslandConfig;